import omit from 'lodash/omit'

import { sectionsMap } from '@/components/sections'

type BuilderProps = {
  sections?: {
    acf_fc_layout: string
  }[]
}

const Builder = ({ sections }: BuilderProps) => {
  return (
    <>
      {sections?.map(({ acf_fc_layout, ...section }, index) => {
        const Section = sectionsMap[acf_fc_layout]
        return (
          <Section
            key={`section-${index}`}
            className="relative z-section"
            data-name={acf_fc_layout}
            {...omit(section, [
              'rep_collection',
              'rel_collection',
              'collection_type'
            ])}
          />
        )
      })}
    </>
  )
}

export default Builder
